import { AgencyTable } from "./AgencyTable";
import { AISection } from "./AISection";
import { CapabilityShift } from "./CapabilityShift";
import { Collaboration } from "./Collaboration";
import { Credibility } from "./Credibility";
import { FooterFull } from "./FooterFull";
import { HeroFull } from "./HeroFull";
import { HowItWorks } from "./HowItWorks";
import { NavFull } from "./NavFull";
import { Outcomes } from "./Outcomes";
import { ProductPeek } from "./ProductPeek";
import { Reframe } from "./Reframe";
import { Shift } from "./Shift";
import { graphite } from "./theme";
import { WhatRarionDoes } from "./WhatRarionDoes";
import { WhyAgencies } from "./WhyAgencies";

export type FullLandingPageProps = {
  currentUser: { name: string; appUrl: string } | null;
  signInUrl: string;
  copyrightYear: number;
};

export function FullLandingPage(props: FullLandingPageProps) {
  const theme = graphite;
  return (
    <div style={{ background: theme.bg, color: theme.fg, fontFamily: theme.font }}>
      <NavFull theme={theme} signInUrl={props.signInUrl} currentUser={props.currentUser} />
      <HeroFull theme={theme} />
      <WhyAgencies theme={theme} />
      <Reframe theme={theme} />
      <Shift theme={theme} />
      <WhatRarionDoes theme={theme} />
      <Collaboration theme={theme} />
      <ProductPeek theme={theme} />
      <AISection theme={theme} />
      <HowItWorks theme={theme} />
      <CapabilityShift theme={theme} />
      <AgencyTable theme={theme} />
      <Outcomes theme={theme} />
      <Credibility theme={theme} />
      <FooterFull
        theme={theme}
        signInUrl={props.signInUrl}
        currentUser={props.currentUser}
        copyrightYear={props.copyrightYear}
      />
    </div>
  );
}
